const OrderCard = () => import("@/components/OrderPage/OrderCard/index");
const OrdersList = () => import("@/components/OrderPage/OrdersList/index");
const PricesTable = () => import("@/components/OrderPage/PricesTable/index");
const tradingView = () => import("@/components/tradingView/index");
import {
  CurrenciesService,
  WalletService,
  OrderService,
  MarketService
} from "@/services";
import socket from "@/services/sockets/socket";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import $rate from "@/mixins/rate";

export default {
  name: "order-page",
  mixins: [$rate],
  components: {
    OrderCard,
    OrdersList,
    PricesTable,
    tradingView
  },
  props: [],
  data() {
    return {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
      priceTableHeight: 0,
      priceTableWidth: 0,
      currencies: [],
      showAnimation: false,
      walletLoaded: false,
      marketOrdersList: [
        /* {
          iso: "BTC",
          type: "خرید",
          status: "باز",
          amount: "0.012345678",
          price: "28,000",
          total: "36,000"
        },
        {
          iso: "ETH",
          type: "خرید",
          status: "باز",
          amount: "0.012345678",
          price: "28,000",
          total: "36,000"
        },
        {
          iso: "ETH",
          type: "خرید",
          status: "انجام شده",
          amount: "0.012345678",
          price: "28,000",
          total: "36,000"
        }*/
      ]
    };
  },
  computed: {
    ...mapGetters({
      currenciesData: types.currencies.getters.GET_CURRENCIES,
      getSelectedBaseCurrency: types.market.getters.GET_SELECTED_BASE_CURRENCY,
      userSetting: types.userSetting.getters.GET_USER_SETTING
    })
  },
  async mounted() {
    await this.handleCryptoPrices();
    await this.initWebSocket();
    await this.getUserWallet();
    await this.getOrdersData();
    // await this.getUserInfo();
    this.getBaseCurrenciesList();
    this.getAvailableMarket();
    this.getDimensions();
  },
  beforeDestroy() {
    socket.ECHO.leaveChannel("prices");
  },
  methods: {
    ...mapActions({
      currenciesDataAction: types.currencies.actions.SET_CURRENCIES,
      setOrdersData: types.order.actions.SET_ORDERS_DATA,
      walletDataAction: types.wallets.actions.SET_WALLETS,
      setToCurrency: types.market.actions.SET_TO_CURRENCY,
      setUserInfo: types.userInfo.actions.ACTION_USER_INFO,
      setMarketData: types.market.actions.SET_AVAILABLE_MARKET_DATA,
      setBaseCurrencies: types.market.actions.SET_BASE_CURRENCIES_DATA
    }),
    getAvailableMarket() {
      MarketService.getAvailableMarketList().then(response => {
        this.setMarketData(response.data.data);
      });
    },
    getBaseCurrenciesList() {
      MarketService.getBaseCurrencies().then(response => {
        this.setBaseCurrencies(response.data.data);
      });
    },
    getDimensions() {
      this.priceTableHeight =
        document.getElementById("priceTableContainer").offsetHeight - 110 > 650
          ? document.getElementById("priceTableContainer").offsetHeight - 110
          : 650;
      this.priceTableWidth = document.getElementById(
        "priceTableContainer"
      ).offsetWidth;
    },
    async getUserWallet() {
      WalletService.getWallet().then(response => {
        this.walletDataAction(response.data.data).then(() => {
          this.walletLoaded = true;
        });
      });
    },
    async handleCryptoPrices() {
      CurrenciesService.getCurrencies().then(async response => {
        await this.handleWebSocketData(response.data.data);
      });
    },
    async initWebSocket() {
      socket.ECHO.channel("currencies").listen(
        ".currency.updated",
        async event => {
          await this.handleWebSocketData(event.data);
        }
      );
    },
    async handleWebSocketData(socketData) {
      this.showAnimation = false;
      this.currencies = await socketData;
      if (this.currenciesData.length !== 0) {
        await this.currencies.forEach(elem => {
          this.currenciesData.find(function(data) {
            if (data.iso === elem.iso) {
              if (data.price > elem.price) {
                elem.price_status = "fall";
              } else if (data.price < elem.price) {
                elem.price_status = "raise";
              } else {
                elem.price_status = "static";
              }
            }
          });
        });
      } else {
        await this.currencies.forEach(elem => {
          elem.price_status = "static";
        });
      }
      await this.currenciesDataAction(this.currencies);
      this.showAnimation = true;
    },
    getOrdersData() {
      const filters = {
        sort: "desc"
      };
      OrderService.getMarketOrders(filters).then(response => {
        this.setOrdersData(response.data);
      });
    }
    // getUserInfo() {
    //   AuthService.userInfo().then(response => {
    //     this.setUserInfo(response.data);
    //   });
    // }
  }
};
